document.querySelectorAll(".marquee-slider").forEach((slider) => {
    const parent = slider.closest(".marquee");
    const isRightDirection = parent.classList.contains("marquee-right");
    new Swiper(slider, {
        slidesPerView: "auto",
        spaceBetween: 0,
        loop: true,
        speed: 6000,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
            reverseDirection: isRightDirection
        }
    });
});
let reviewSwiper = null;
const progressBar = document.querySelector(".review_progress span");

function initReviewSwiper() {
    const isMobile = window.innerWidth < 768;
    /* =========================
       DESKTOP
    ========================= */
    if (!isMobile && !reviewSwiper) {
        const slider = document.querySelector(".review_swiper");
        const wrapper = slider?.querySelector(".swiper-wrapper");
        /*
         * Make sure there are enough slides
         * for loop mode.
         */
        if(!slider || !wrapper) return;
        const originalSlides = Array.from(wrapper.querySelectorAll(".swiper-slide"));
        const minSlides = 10;
      
          if (originalSlides.length > 0 && originalSlides.length < minSlides) {
            const copiesNeeded = Math.ceil(minSlides / originalSlides.length);
            for (let i = 1; i < copiesNeeded; i++) {
                originalSlides.forEach((slide) => {
                    const clone = slide.cloneNode(true);
                    wrapper.appendChild(clone);
                });
            }
        }
        reviewSwiper = new Swiper(".review_swiper", {
            slidesPerView: "auto",
            spaceBetween: 20,
            loop: true,
            speed: 600,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            on: {
                init: function() {
                    updateProgress(this);
                },
                slideChange: function() {
                    updateProgress(this);
                },
                resize: function() {
                    updateProgress(this);
                }
            }
        });
    }
    /* =========================
       MOBILE
    ========================= */
    if (isMobile && reviewSwiper) {
        reviewSwiper.destroy(true, true);
        reviewSwiper = null;
        if (progressBar) {
            progressBar.style.width = "0%";
        }
    }
}
/* =========================
   PROGRESS
========================= */
function updateProgress(swiper) {
    if (!progressBar) return;
    /*
     * For loop mode use realIndex.
     * realIndex = original slide index.
     */
    const totalSlides = swiper.slides.length;
    const currentSlide = swiper.realIndex + 1;
    let percentage = (currentSlide / totalSlides) * 100;
    percentage = Math.min(Math.max(percentage, 0), 100);
    progressBar.style.width = percentage + "%";
}
/* =========================
   INITIALIZE
========================= */
initReviewSwiper();
/* =========================
   RESIZE
========================= */
let resizeTimer;
window.addEventListener("resize", function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
        initReviewSwiper();
    }, 200);
});
// dev_k
document.addEventListener("DOMContentLoaded", () => {
  // dev_r
const menuToggle = document.querySelector(".menu-toggle");
const navMenu = document.querySelector(".nav-menu");
const menuClose = document.querySelector(".menu-close");

const closeMenu = () => {
  navMenu?.classList.remove("is-open");
  menuToggle?.setAttribute("aria-expanded", "false");
};

menuToggle?.addEventListener("click", () => {
  console.log("hello")
  const isOpen = navMenu.classList.toggle("is-open");
  menuToggle.setAttribute("aria-expanded", String(isOpen));
});

menuClose?.addEventListener("click", closeMenu);

document.addEventListener("click", (event) => {
  if (
    navMenu?.classList.contains("is-open") &&
    !navMenu.contains(event.target) &&
    !menuToggle?.contains(event.target)
  ) {
    closeMenu();
  }
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") {
    closeMenu();
  }
});


//     /* THUMBNAIL SWIPER */
//   const thumbSwiper = new Swiper(".thumb-slider", {
//       slidesPerView: 4,
//       spaceBetween: 16,
//       watchSlidesProgress: true,
//       freeMode: false,

//       navigation: {
//           nextEl: ".thumb-next",
//           prevEl: ".thumb-prev",
//       },

//       breakpoints: {
//           576: {
//               slidesPerView: 5,
//           }
//       }
//   });
//     /* MAIN SWIPER */
//     const mainSwiper = new Swiper(".order_slide_main", {
//         slidesPerView: 1,
//         spaceBetween: 0,
//         effect: "creative",
//         creativeEffect: {
//             prev: {
//                 opacity: 0,
//                 translate: ["-20%", 0, 0],
//             },
//             next: {
//                 opacity: 0,
//                 translate: ["20%", 0, 0],
//             },
//         },
//         thumbs: {
//             swiper: thumbSwiper,
//         },
//     });

//     /* THUMB ARROWS CHANGE MAIN SLIDE */
// thumbSwiper.on("slideNextTransitionStart", function () {
//     mainSwiper.slideNext();
// });

// thumbSwiper.on("slidePrevTransitionStart", function () {
//     mainSwiper.slidePrev();
// });

    
const thumbEl = document.querySelector(".thumb-slider");
const mainEl = document.querySelector(".order_slide_main");

if (!thumbEl || !mainEl) return;

// Destroy previous instances
if (thumbEl.swiper) thumbEl.swiper.destroy(true, true);
if (mainEl.swiper) mainEl.swiper.destroy(true, true);

/* THUMBNAILS */
const thumbSwiper = new Swiper(thumbEl, {
    slidesPerView: 3.7,
    spaceBetween: 16,
    speed: 400,
    loop: false,
    watchOverflow: false,
    watchSlidesProgress: true,

    breakpoints: {
        576: {
            slidesPerView: 4.7,
        },
        480: {
          slidesPerView: 3.7
        }
    },
});

/* ACTIVE THUMBNAIL FUNCTION */

function updateActiveThumbnail(index) {

    const totalSlides = thumbSwiper.slides.length;

    // Update active thumbnail
    thumbSwiper.slides.forEach((slide, i) => {
        slide.classList.toggle(
            "swiper-slide-thumb-active",
            i === index
        );
    });

    const visible = Number(thumbSwiper.params.slidesPerView);

    // If main slider reaches the last slide
    if (index === totalSlides - 1) {
        thumbSwiper.slideTo(
            Math.max(0, totalSlides - Math.ceil(visible))
        );
    } else {
        const firstVisible = thumbSwiper.activeIndex;
        const lastVisible = firstVisible + visible - 1;

        if (index < firstVisible) {
            thumbSwiper.slideTo(index);
        } else if (index > lastVisible) {
            thumbSwiper.slideTo(
                index - Math.floor(visible) + 1
            );
        }
    }

    // Update overlay
    thumbEl.classList.toggle(
        "hide-right-overlay",
        thumbSwiper.isEnd
    );
}


/* MAIN SLIDER */
const mainSwiper = new Swiper(mainEl, {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 500,
    loop: false,
    rewind: true,
    effect: "creative",

    creativeEffect: {
        prev: {
            opacity: 0,
            translate: ["-20%", 0, 0],
        },
        next: {
            opacity: 0,
            translate: ["20%", 0, 0],
        },
    },

    navigation: {
        nextEl: ".thumb-next",
        prevEl: ".thumb-prev",
    },

    on: {
        slideChange: function () {
            updateActiveThumbnail(this.activeIndex);
        },
    },
});

/* CLICK THUMBNAIL */
thumbSwiper.on("click", function (swiper) {
    if (swiper.clickedIndex == null) return;

    mainSwiper.slideTo(swiper.clickedIndex);
});

/* INITIAL STATE */
updateActiveThumbnail(mainSwiper.activeIndex);

/* ADULT BUTTON */
const adltButtons = document.querySelectorAll(".adult_btn_wrap a");

adltButtons.forEach((button) => {
    button.addEventListener("click", function (e) {
        e.preventDefault();

        adltButtons.forEach((item) => {
            item.classList.remove("active");
        });

        this.classList.add("active");
    });
});

    // order product
    let productItem = document.querySelectorAll(".order_gift_inr_item");
    let subscribeCheck = document.querySelector(".subscribe_check");
    let subscribeWrap = document.querySelector(".subscribe_wrap");
    let selectedProduct = null;
    // Product selection
    productItem.forEach((item) => {
        item.addEventListener("click", function(e) {
            e.preventDefault();
            // Don't allow product selection when subscribe is checked
            if (subscribeCheck.checked) {
                return;
            }
            productItem.forEach((i) => {
                i.classList.remove("active");
            });
            this.classList.add("active");
            // Remember selected product
            selectedProduct = this;
        });
    });
    // Subscribe checkbox
    subscribeCheck?.addEventListener("change", function() {
        if (this.checked) {
            // Remember currently selected product
            selectedProduct = document.querySelector(".order_gift_inr_item.active");
            subscribeWrap.classList.add("active");
            // Remove active product
            productItem.forEach((item) => {
                item.classList.remove("active");
                item.classList.add("disabled");
            });
        } else {
            subscribeWrap.classList.remove("active");
            // Enable products again
            productItem.forEach((item) => {
                item.classList.remove("disabled");
            });
            // Restore previously selected product
            if (selectedProduct) {
                selectedProduct.classList.add("active");
            }
        }
    });
})



const heroMarquee = document.querySelector(".hero-marquee");

if (heroMarquee) {
  new Swiper(heroMarquee, {
    spaceBetween: 0,
    centeredSlides: true,
    speed: 6000,
    autoplay: {
      delay: 1,
    },
    loop: true,
    slidesPerView: "auto",
    allowTouchMove: false,
    disableOnInteraction: true,
  });
}

const wellnessBenefitsSlider = document.querySelector(".wellness-benefits__slider");

// if (wellnessBenefitsSlider) {
//   const wellnessSlides = wellnessBenefitsSlider.querySelectorAll(".swiper-slide");

//   wellnessSlides.forEach((slide) => {
//     const duplicateSlide = slide.cloneNode(true);
//     duplicateSlide.setAttribute("aria-hidden", "true");
//     wellnessBenefitsSlider.querySelector(".swiper-wrapper").appendChild(duplicateSlide);
//   });

//   new Swiper(wellnessBenefitsSlider, {
//     slidesPerView: 3.15,
//     spaceBetween: 14,
//     centeredSlides: true,
//     loop: true,
//     speed: 800,
//     autoplay: {
//       delay: 2000,
//       disableOnInteraction: false,
//       pauseOnMouseEnter: true,
//     },
//     grabCursor: true,
//     breakpoints: {
//       576: {
//         slidesPerView: 2.2,
//         spaceBetween: 14,
//       },
//       992: {
//         slidesPerView: 3.2,
//         spaceBetween: 14,
//       },
//       1400: {
//         slidesPerView: 3.2,
//         spaceBetween: 14,
//       },
//       1639: {
//         slidesPerView: 3.4,
//         spaceBetween: 14,
//       },
//       1640: {
//         slidesPerView: 3.7,
//         spaceBetween: 14,
//       },
//     },
//   });
// }


if (wellnessBenefitsSlider) {
  const wrapper = wellnessBenefitsSlider.querySelector(".swiper-wrapper");
  const originalSlides = Array.from(
    wellnessBenefitsSlider.querySelectorAll(".swiper-slide")
  );

  let wellnessSwiper;

  function initWellnessSwiper() {
    // Destroy existing Swiper before re-initializing
    if (wellnessSwiper) {
      wellnessSwiper.destroy(true, true);
      wellnessSwiper = null;
    }

    // Remove previously created duplicate slides
    wrapper.querySelectorAll(".wellness-slide-duplicate").forEach((slide) => {
      slide.remove();
    });

    const isMobile = window.innerWidth <= 767;

    /*
     * MOBILE
     * 2 columns × 3 rows
     */
    if (isMobile) {
      wellnessSwiper = new Swiper(wellnessBenefitsSlider, {
        slidesPerView: 2,
        grid: {
          rows: 3,
          fill: "row",
        },
        spaceBetween: 8,

        centeredSlides: false,
        loop: false,

        speed: 500,
        grabCursor: false,

        // No autoplay on mobile
        autoplay: false,
      });
    }

    /*
     * DESKTOP
     * Keep your existing behavior
     */
    else {
      originalSlides.forEach((slide) => {
        const duplicateSlide = slide.cloneNode(true);

        duplicateSlide.classList.add("wellness-slide-duplicate");
        duplicateSlide.setAttribute("aria-hidden", "true");

        wrapper.appendChild(duplicateSlide);
      });

      wellnessSwiper = new Swiper(wellnessBenefitsSlider, {
        slidesPerView: 3.15,
        spaceBetween: 14,
        centeredSlides: true,
        loop: true,
        speed: 800,

        autoplay: {
          delay: 2000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },

        grabCursor: true,

        breakpoints: {
          576: {
            slidesPerView: 2.2,
            spaceBetween: 14,
          },

          992: {
            slidesPerView: 3.2,
            spaceBetween: 14,
          },

          1400: {
            slidesPerView: 3.2,
            spaceBetween: 14,
          },

          1639: {
            slidesPerView: 3.4,
            spaceBetween: 14,
          },

          1640: {
            slidesPerView: 3.7,
            spaceBetween: 14,
          },
        },
      });
    }
  }

  // Initial load
  initWellnessSwiper();

  // Reinitialize when crossing the 767px breakpoint
  let lastIsMobile = window.innerWidth <= 767;

  window.addEventListener("resize", () => {
    const currentIsMobile = window.innerWidth <= 767;

    if (currentIsMobile !== lastIsMobile) {
      lastIsMobile = currentIsMobile;
      initWellnessSwiper();
    }
  });
}

document.addEventListener("DOMContentLoaded", () => {
      const cards = document.querySelectorAll(".customer-story-card");
      const progressFill = document.querySelector(".customer-story-progress__fill");
      let suppressAutoplayResume = false;

      function updateProgress(swiper) {
        const totalSlides = cards.length;
        const currentSlide = swiper.realIndex + 1;

        if (!progressFill || !totalSlides) return;

        progressFill.style.width = `${(currentSlide / totalSlides) * 100}%`;
      }

      function pauseAllVideos(exceptVideo = null) {
        cards.forEach(card => {
          const video = card.querySelector("video");
          const button = card.querySelector(".customer-story-card__toggle");

          if (!video || video === exceptVideo) return;

          suppressAutoplayResume = true;
          video.pause();
          suppressAutoplayResume = false;
          card.classList.remove("is-playing");

          if (button) {
            button.setAttribute("aria-label", "Play video");
          }
        });
      }

      /*
       * Swiper
       * - autoplay: automatically moves to the next slide
       * - loop: continuously cycles through the slides
       * - disableOnInteraction: false keeps autoplay running after dragging/clicking
       */
      const slider = new Swiper(".customer-story-slider", {
        slidesPerView: "auto",
        spaceBetween: 8,
        speed: 600,
        grabCursor: true,
        loop: true,
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
          pauseOnMouseEnter: false
        },

        /* Start from slide 2 so the initial state looks like the screenshot. */
        initialSlide: 1,

        breakpoints: {
          0: {
            spaceBetween: 8
          },
          768: {
            spaceBetween: 8
          }
        },

        on: {
          init(swiper) {
            updateProgress(swiper);
          },

          slideChange(swiper) {
            updateProgress(swiper);
            pauseAllVideos();
          }
        }
      });

      cards.forEach(card => {
        const video = card.querySelector("video");
        const button = card.querySelector(".customer-story-card__toggle");

        if (!video || !button) return;

        button.addEventListener("click", event => {
          event.preventDefault();
          event.stopPropagation();

          /* Only one testimonial video can play at a time. */
          pauseAllVideos(video);

          if (video.paused) {
            video.play()
              .then(() => {
                card.classList.add("is-playing");
                button.setAttribute("aria-label", "Pause video");
              })
              .catch(error => {
                console.warn("Video could not be played:", error);
              });
          } else {
            video.pause();
            card.classList.remove("is-playing");
            button.setAttribute("aria-label", "Play video");
            slider.autoplay.start();
          }
        });

        video.addEventListener("play", () => {
          slider.autoplay.stop();
        });

        video.addEventListener("pause", () => {
          if (!suppressAutoplayResume) {
            slider.autoplay.start();
          }
        });

        video.addEventListener("ended", () => {
          card.classList.remove("is-playing");
          button.setAttribute("aria-label", "Play video");
          slider.autoplay.start();
        });
      });


      // footer 
  // const footerItems = document.querySelectorAll(".ftr_lnks_itm");
  // const mobileMql = window.matchMedia("(max-width: 575px)");
  // const isMobile = () => mobileMql.matches;
  // function initItem(item) {
  //   const heading = item.querySelector("h6");
  //   const ul = item.querySelector("ul");
  //   if (!heading || !ul) return null;
  //   return { item, heading, ul };
  // }
  // function applyState(entry, mobile) {
  //   const { item, ul } = entry;
  //   if (mobile) {
  //     ul.style.overflow = "hidden";
  //     ul.style.transition = "height 0.4s ease, padding-bottom 0.4s ease";
  //     if (item.dataset.open === undefined) {
  //       item.dataset.open = "false";
  //     }
  //     if (item.dataset.open === "true") {
  //       ul.style.height = "auto";
  //       ul.style.paddingBottom = "28px";
  //     } else {
  //       ul.style.height = "0px";
  //       ul.style.paddingBottom = "0px";
  //     }
  //   } else {
  //     ul.style.height = "auto";
  //     ul.style.paddingBottom = "";
  //     ul.style.overflow = "visible";
  //     ul.style.transition = "none";
  //   }
  // }
  // const entries = Array.from(footerItems).map(initItem).filter(Boolean);
  // function setupFooterAccordion() {
  //   const mobile = isMobile();
  //   entries.forEach((entry) => applyState(entry, mobile));
  // }
  // function settleHeight(ul, item) {
  //   clearTimeout(ul._settleTimer);
  //   ul._settleTimer = setTimeout(() => {
  //     if (item.dataset.open === "true") {
  //       ul.style.height = "auto";
  //     }
  //   }, 450);
  // }
  // entries.forEach(({ item, heading, ul }) => {
  //   heading.addEventListener("click", function () {
  //     if (!isMobile()) return;
  //     const isOpen = item.dataset.open === "true";
  //     if (ul._transitionHandler) {
  //       ul.removeEventListener("transitionend", ul._transitionHandler);
  //       ul._transitionHandler = null;
  //     }
  //     clearTimeout(ul._settleTimer);
  //     if (isOpen) {
  //       const currentHeight = ul.scrollHeight;
  //       ul.style.height = currentHeight + "px";
  //       ul.offsetHeight; 
  //       requestAnimationFrame(() => {
  //         ul.style.height = "0px";
  //         ul.style.paddingBottom = "0px";
  //       });
  //       item.dataset.open = "false";
  //     } else {
  //       ul.style.height = "0px";
  //       ul.style.paddingBottom = "0px";
  //       ul.offsetHeight; 
  //       const contentHeight = ul.scrollHeight;
  //       requestAnimationFrame(() => {
  //         ul.style.paddingBottom = "28px";
  //         ul.style.height = contentHeight + 28 + "px";
  //       });
  //       item.dataset.open = "true";
  //       const handleTransitionEnd = (event) => {
  //         if (event.propertyName !== "height") return;
  //         if (item.dataset.open === "true") {
  //           ul.style.height = "auto";
  //         }
  //         ul.removeEventListener("transitionend", handleTransitionEnd);
  //         ul._transitionHandler = null;
  //         clearTimeout(ul._settleTimer);
  //       };
  //       ul._transitionHandler = handleTransitionEnd;
  //       ul.addEventListener("transitionend", handleTransitionEnd);
  //       settleHeight(ul, item);
  //     }
  //   });
  // });
  // setupFooterAccordion();
  // mobileMql.addEventListener("change", setupFooterAccordion);
  

// const footerItems = document.querySelectorAll(".ftr_lnks_itm");
// const mobileMql = window.matchMedia("(max-width: 575px)");
// const isMobile = () => mobileMql.matches;

// function initItem(item) {
//   const heading = item.querySelector("h6");
//   const ul = item.querySelector("ul");

//   if (!heading || !ul) return null;
//   return { item, heading, ul };
// }

// const entries = Array.from(footerItems).map(initItem).filter(Boolean);

// function applyState(entry, mobile) {
//   const { item, heading, ul } = entry;

//   if (mobile) {
//     ul.style.overflow = "hidden";
//     ul.style.transition = "height 0.4s ease, padding-bottom 0.4s ease";

//     if (item.dataset.open === undefined) {
//       item.dataset.open = "false";
//     }

//     const isOpen = item.dataset.open === "true";
//     heading.classList.toggle("active", isOpen);

//     if (isOpen) {
//       ul.style.height = "auto";
//       ul.style.paddingBottom = "28px";
//     } else {
//       ul.style.height = "0px";
//       ul.style.paddingBottom = "0px";
//     }
//   } else {
//     heading.classList.remove("active");
//     ul.style.height = "auto";
//     ul.style.paddingBottom = "";
//     ul.style.overflow = "visible";
//     ul.style.transition = "none";
//   }
// }

// function setupFooterAccordion() {
//   entries.forEach((entry) => applyState(entry, isMobile()));
// }

// function settleHeight(ul, item) {
//   clearTimeout(ul._settleTimer);

//   ul._settleTimer = setTimeout(() => {
//     if (item.dataset.open === "true") {
//       ul.style.height = "auto";
//     }
//   }, 450);
// }

// function closeOtherItems(currentItem) {
//   entries.forEach(({ item, heading, ul }) => {
//     if (item === currentItem) return;

//     if (ul._transitionHandler) {
//       ul.removeEventListener("transitionend", ul._transitionHandler);
//       ul._transitionHandler = null;
//     }

//     clearTimeout(ul._settleTimer);

//     if (item.dataset.open !== "true") {
//       heading.classList.remove("active");
//       ul.style.height = "0px";
//       ul.style.paddingBottom = "0px";
//       return;
//     }

//     // Freeze current height before closing animation
//     ul.style.height = ul.scrollHeight + "px";
//     ul.offsetHeight;

//     item.dataset.open = "false";
//     heading.classList.remove("active");

//     requestAnimationFrame(() => {
//       ul.style.height = "0px";
//       ul.style.paddingBottom = "0px";
//     });
//   });
// }

// entries.forEach(({ item, heading, ul }) => {
//   heading.addEventListener("click", function () {
//     if (!isMobile()) return;

//     const isOpen = item.dataset.open === "true";

//     // Close all other sections
//     closeOtherItems(item);

//     if (ul._transitionHandler) {
//       ul.removeEventListener("transitionend", ul._transitionHandler);
//       ul._transitionHandler = null;
//     }

//     clearTimeout(ul._settleTimer);

//     if (isOpen) {
//       // Close the clicked section
//       ul.style.height = ul.scrollHeight + "px";
//       ul.offsetHeight;

//       item.dataset.open = "false";
//       heading.classList.remove("active");

//       requestAnimationFrame(() => {
//         ul.style.height = "0px";
//         ul.style.paddingBottom = "0px";
//       });

//       return;
//     }

//     // Open the clicked section
//     ul.style.height = "0px";
//     ul.style.paddingBottom = "0px";
//     ul.offsetHeight;

//     const contentHeight = ul.scrollHeight;

//     item.dataset.open = "true";
//     heading.classList.add("active");

//     requestAnimationFrame(() => {
//       ul.style.paddingBottom = "28px";
//       ul.style.height = contentHeight + 28 + "px";
//     });

//     const handleTransitionEnd = (event) => {
//       if (event.propertyName !== "height") return;

//       if (item.dataset.open === "true") {
//         ul.style.height = "auto";
//       }

//       ul.removeEventListener("transitionend", handleTransitionEnd);
//       ul._transitionHandler = null;
//       clearTimeout(ul._settleTimer);
//     };

//     ul._transitionHandler = handleTransitionEnd;
//     ul.addEventListener("transitionend", handleTransitionEnd);

//     settleHeight(ul, item);
//   });
// });

// setupFooterAccordion();
// mobileMql.addEventListener("change", setupFooterAccordion);

    });



(function () {
  function initCustomScrollbars() {
    if (window.innerWidth > 767) return;

    document.querySelectorAll('.compari_table_wrp').forEach(function (wrapper) {
      if (wrapper.dataset.customScrollbarInit === 'true') return;
      wrapper.dataset.customScrollbarInit = 'true';

      var track = document.createElement('div');
      track.className = 'custom-scroll-track';

      var thumb = document.createElement('div');
      thumb.className = 'custom-scroll-thumb';

      track.appendChild(thumb);
      wrapper.appendChild(track);

      function updateScrollbar() {
        var viewportWidth = wrapper.clientWidth;
        var contentWidth = wrapper.scrollWidth;
        var maxScroll = contentWidth - viewportWidth;
        var trackWidth = track.clientWidth;

        if (maxScroll <= 1 || trackWidth <= 0) {
          track.style.display = 'none';
          return;
        }

        track.style.display = 'block';

        var thumbWidth = Math.max(
          30,
          (viewportWidth / contentWidth) * trackWidth
        );

        thumbWidth = Math.min(thumbWidth, trackWidth);
        thumb.style.width = thumbWidth + 'px';

        var maxThumbMove = trackWidth - thumbWidth;
        var scrollRatio = wrapper.scrollLeft / maxScroll;

        thumb.style.transform =
          'translateX(' + (scrollRatio * maxThumbMove) + 'px)';
      }

      wrapper.addEventListener('scroll', updateScrollbar, {
        passive: true
      });

      track.addEventListener('click', function (event) {
        if (event.target === thumb) return;

        var rect = track.getBoundingClientRect();
        var clickPosition = event.clientX - rect.left;
        var maxThumbMove = track.clientWidth - thumb.offsetWidth;
        var targetPosition = clickPosition - thumb.offsetWidth / 2;

        targetPosition = Math.max(
          0,
          Math.min(targetPosition, maxThumbMove)
        );

        var maxScroll = wrapper.scrollWidth - wrapper.clientWidth;

        wrapper.scrollLeft = maxThumbMove > 0
          ? (targetPosition / maxThumbMove) * maxScroll
          : 0;
      });

      var dragging = false;
      var startX = 0;
      var startLeft = 0;

      thumb.addEventListener('pointerdown', function (event) {
        dragging = true;
        startX = event.clientX;
        startLeft = wrapper.scrollLeft;
        thumb.setPointerCapture(event.pointerId);
        event.preventDefault();
      });

      thumb.addEventListener('pointermove', function (event) {
        if (!dragging) return;

        var maxScroll = wrapper.scrollWidth - wrapper.clientWidth;
        var maxThumbMove = track.clientWidth - thumb.offsetWidth;

        if (maxThumbMove <= 0) return;

        var delta = event.clientX - startX;

        wrapper.scrollLeft = startLeft +
          (delta / maxThumbMove) * maxScroll;
      });

      function stopDragging() {
        dragging = false;
      }

      thumb.addEventListener('pointerup', stopDragging);
      thumb.addEventListener('pointercancel', stopDragging);

      if ('ResizeObserver' in window) {
        new ResizeObserver(updateScrollbar).observe(wrapper);
      }

      window.addEventListener('resize', updateScrollbar);

      requestAnimationFrame(updateScrollbar);
      setTimeout(updateScrollbar, 300);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomScrollbars);
  } else {
    initCustomScrollbars();
  }
})();



(function () {
  function initCustomScrollbars() {
    document.querySelectorAll('.routine_table_wrp').forEach(function (wrapper) {
      var scroller = wrapper.querySelector('.routine_table_scrllr');

      if (!scroller || scroller.dataset.customScrollbarInit === 'true') return;
      scroller.dataset.customScrollbarInit = 'true';

      var track = document.createElement('div');
      track.className = 'custom-scroll-track';

      var thumb = document.createElement('div');
      thumb.className = 'custom-scroll-thumb';

      track.appendChild(thumb);
      wrapper.appendChild(track);

      function updateScrollbar() {
        if (window.innerWidth > 767) {
          track.style.display = 'none';
          return;
        }

        var viewportWidth = scroller.clientWidth;
        var contentWidth = scroller.scrollWidth;
        var trackWidth = track.clientWidth;
        var maxScroll = contentWidth - viewportWidth;

        if (maxScroll <= 1 || trackWidth <= 0) {
          track.style.display = 'none';
          return;
        }

        track.style.display = 'block';

        var thumbWidth = Math.min(
          trackWidth,
          Math.max(30, trackWidth * viewportWidth / contentWidth)
        );

        thumb.style.width = thumbWidth + 'px';

        var maxThumbMove = trackWidth - thumbWidth;
        var ratio = Math.max(0, Math.min(1, scroller.scrollLeft / maxScroll));

        thumb.style.transform =
          'translateX(' + ratio * maxThumbMove + 'px)';
      }

      // Update thumb when the table itself scrolls
      scroller.addEventListener('scroll', updateScrollbar, { passive: true });

      // Clicking the track moves the table
      track.addEventListener('click', function (event) {
        if (event.target === thumb) return;

        var rect = track.getBoundingClientRect();
        var thumbWidth = thumb.offsetWidth;
        var maxThumbMove = track.clientWidth - thumbWidth;
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;

        if (maxThumbMove <= 0) return;

        var target = event.clientX - rect.left - thumbWidth / 2;
        target = Math.max(0, Math.min(target, maxThumbMove));

        scroller.scrollLeft = target / maxThumbMove * maxScroll;
      });

      // Drag the thumb on touchscreens and desktops
      var dragging = false;
      var startX = 0;
      var startScroll = 0;

      thumb.addEventListener('pointerdown', function (event) {
        dragging = true;
        startX = event.clientX;
        startScroll = scroller.scrollLeft;

        thumb.setPointerCapture(event.pointerId);
        event.preventDefault();
      });

      thumb.addEventListener('pointermove', function (event) {
        if (!dragging) return;

        var maxThumbMove = track.clientWidth - thumb.offsetWidth;
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;

        if (maxThumbMove <= 0) return;

        scroller.scrollLeft = startScroll +
          (event.clientX - startX) / maxThumbMove * maxScroll;
      });

      function stopDragging() {
        dragging = false;
      }

      thumb.addEventListener('pointerup', stopDragging);
      thumb.addEventListener('pointercancel', stopDragging);

      window.addEventListener('resize', updateScrollbar);

      if ('ResizeObserver' in window) {
        var observer = new ResizeObserver(updateScrollbar);
        observer.observe(scroller);
        observer.observe(wrapper);
      }

      requestAnimationFrame(updateScrollbar);
      setTimeout(updateScrollbar, 500);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCustomScrollbars);
  } else {
    initCustomScrollbars();
  }
})();

